// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';

// Components
const MemberTableComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "member-table-component"*/ '@/app/views/main-view/social-club/components/member-table-component/member-table-component.vue');

// Store
import store from '@/app/stores/store';

// Services
import ClubService from '@/app/services/main/club/club-service.js';

// Third Party libraries
import * as $ from 'jquery';

// Constants
import { STATUS_CODES, USER_CLUB_STATUS } from '@/app/constants/status-constants';

export default {
    name: 'ModalSocialMemberRequest',
    components: {
	    MemberTableComponent
    },
    mixins: [
        toastMessageMixins,
        tableMixins
    ],
    data() {
        return {
            isAPILoading: false,
            searchMember: '',
            pendingMembers: [],
            isGetMembersLoading: false
        }
    },
    beforeDestroy() {
        this.closeModal();
    },
    methods: {
        openModal() {
            $(this.$refs.memberRequestModal).modal('show');
            this.columnsFilter = {};
            this.searchMember = '';
            this.getTableContent();
        },
        closeModal() {
	        $(this.$refs.memberRequestModal).modal('hide');
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {

			page = fromFilter ? 1 : this.page;
			
			this.getPendingMembers({ page, limit, sortBy, desc });
		},
        getPendingMembers(queryParams) {
            
            const params = {
                ...queryParams,
                sortBy: ''
            }
            const groupId = this.$store.getters.getActiveGroup.id;

            this.isGetMembersLoading = true;

            this.isGetMembersLoading = true;

            params['f_mStatus'] = 'PENDING';

            if (this.columnsFilter) {
				if (this.columnsFilter.f_name) {
					params['f_name'] = this.columnsFilter.f_name; 
				}
            }

            // change this to the specific endpoint
            ClubService.getGroupMembers(groupId, params)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: res.data.data,
                            paginationData: res.data.pagination
                        };
                        
					} else {
                        this.showCustomErrorToast(res.data.errors[0].message, null, true);
					}
                    this.isGetMembersLoading = false;
				})
				.catch(() => {
                    this.isGetMembersLoading = false;
					this.showGenericErrorToast();
				});
        },
        approveDisapproved(params) {
            const status = params.action === 'approve' ? USER_CLUB_STATUS.ACTIVE : USER_CLUB_STATUS.INACTIVE;

            const { getActiveGroup } = store.getters;

            const reqBody = {
                customerIds: [params.customerId],
                status
            }

            this.isAPILoading = true;

            ClubService.updateGroupMemberStatus(getActiveGroup.id, reqBody)
            .then(async res => {
                if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    this.isAPILoading = false;

                    this.$emit('updateAdminManagement');

                    this.showCustomSuccessToast(null, `Successfully ${params.action} member.`);
                    
                    this.getTableContent(this.page, this.limit, this.sortBy, this.desc);

                    await this.$store.dispatch('setGroupAdminRequest');
                } else {
                    this.showCustomErrorToast(res.data.errors[0].message, null, true);
                
                    this.isAPILoading = false;
                }
            })
            .catch(() => {
                this.isAPILoading = false;
                
                this.showCustomErrorToast(res.data.errors[0].message, null, true);
            });
        },
    }
}